<template lang="pug">
.article-data-container(@click="expand = !expand")
  .article-data
    .article-id
      span.material-symbols-outlined description
      span.tag {{ data.article }}

    .article-letter(v-if="!history") {{ data.letter }}

    .article-name.capitalize(v-if="!history") {{ data.spanish }}

    .article-active(v-if="!history")
      span.tag(:style="data.activeArticle ? 'background:#A5AA72;color:#fff' : 'background:#e9e9e7;color:#616161'") {{ data.activeArticle ? 'Activo' : 'Inactivo' }}

    .article-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .article-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

  transition(name="slide-fade")
    shForm.list-article(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-article(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Article',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.article-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.article-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.article-id
  display flex
  align-items center
  gap .5em

.list-article
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .article-data
    column-gap 0
    row-gap 1em

  .article-id
    width 12em
  .article-letter
    width 5em
  .article-name
    width 14em
  .article-active
    width 7em
  .article-transaction
    width 8em
  .article-date
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/article/Article.vue